import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import UserContext from "../../context/user";
import dayjs from "dayjs";

const useGetOsteopathTimeSlots = (selectedOsteopath, selectedDay, currentRequest) => {
  const { userProfile, callApi } = useContext(UserContext);

  const today = dayjs();

  return useQuery(
    ["slots", selectedOsteopath, selectedDay],
    () =>
      callApi(
        `/osteopath/${selectedOsteopath}/availabilities?${new URLSearchParams({
          dateFrom: selectedDay,
        }).toString()}`
      ),
    {
      enabled: !!userProfile && !!selectedOsteopath && !!selectedDay,
      select: (data) =>
        data
          ?.filter(
            (item) =>
              (item.bookingAvailable ||
                (currentRequest?.editMode ? item.date === currentRequest?.bookingDate : false)) &&
              (today.format("DD-MM-YYYY") === selectedDay
                ? dayjs(Number(item.date)).isAfter(today, "minute")
                : true)
          )
          ?.map((date) => dayjs(Number(date.date)))
          ?.sort((a, b) => (a.isBefore(b) ? -1 : a.isAfter(b) ? 1 : 0)),
    }
  );
};

export default useGetOsteopathTimeSlots;
